'use client'

import s from './page.module.scss';
import {
    FIRST_PAGE,
    NEWS_PAGE_BREAD_CRUMB_CONTENT,
    NEWS_PAGE_LABELS
} from "../common/constants/news";
import {Container} from "@/app/[locale]/common/components/Container/Container";
import {Title} from "@/app/[locale]/common/components/Title/Title";
import {Breadcrumbs} from "@/app/[locale]/common/components/Breadcrumbs/Breadcrumbs";
import {FormAdmin} from "@/app/[locale]/common/components/FormAdmin/FormAdmin";
import {NewsClientComponent} from "@/app/[locale]/news/NewsClientComponent/NewsClientComponent";
import {TNewsPageProps} from "@/app/[locale]/news/types";
import {Toast} from "@/app/[locale]/common/components/Toast/Toast";
import {ADMIN_MESSAGES} from "../common/constants/admin";
import {useCreateNews} from "@/app/[locale]/common/utils/hooks/useCreateNews/useCreateNews";
import {handleErrorMessage} from "@/app/[locale]/common/utils/functions/handleErrorMessage/handleErrorMessage";

export default function Page({ searchParams }: TNewsPageProps) {
    const currentPage = parseInt(searchParams.page || FIRST_PAGE, 10);
    const { newsStatus, createNews, error } = useCreateNews(currentPage);

    return (
        <div className={s.news}>
            <Container>
                <Breadcrumbs crumb={[NEWS_PAGE_BREAD_CRUMB_CONTENT.NEWS]} />
                <Title title={NEWS_PAGE_LABELS.ALL_NEWS} />
                <FormAdmin type={'news'} actionStatus={newsStatus} onSubmit={createNews} />
                <NewsClientComponent currentPage={currentPage} />

                {
                    newsStatus === 'success' &&
                    <Toast
                        title={ADMIN_MESSAGES.SUCCESS.title}
                        description={'New was created.'}
                        Icon={ADMIN_MESSAGES.SUCCESS.Icon}
                        isOpen={true}
                    />
                }
                {
                    newsStatus === 'error' &&
                    <Toast
                        title={ADMIN_MESSAGES.ERROR.title}
                        description={handleErrorMessage(error) || ADMIN_MESSAGES.ERROR.description}
                        Icon={ADMIN_MESSAGES.ERROR.Icon}
                        isOpen={true}
                    />
                }
            </Container>
        </div>
    );
};